var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "product-slide" }, [
    _c("div", {
      staticClass: "image",
      style:
        "padding-bottom:" +
        _vm.size +
        "%; background-image: url(" +
        _vm.image +
        ");"
    })
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d5738b1c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5738b1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/shared/sliders/ImageSlide.vue
// module id = gC9f
// module chunks = 0 1 2 3 4 5 6 8 9 10 11 12 13 14 15 16 25 26 28 33